const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

class CollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.facetForm = this.element.querySelector(".js-filters-form");
    this.collectionGrid = this.element.querySelector(".js-product-grid");
    this.sectionID = this.facetForm.dataset.sectionId;
    this.collectionDetail = this.element.querySelector(
      ".collection-description__collapse"
    );

    this.paginateNext = this.element.querySelector(".js-pagination-next");

    this.filtersTitle = this.facetForm.querySelector(".js-filters-title");
    this.sortByItems = this.element.querySelectorAll(".js-sortby");
    this.sortByInput = this.element.querySelectorAll(".js-sortby-input");
    this.productCount = this.element.querySelector(".js-product-count");

    this.bindInit();
  }

  bindInit() {
    this.handleFacets(this.facetForm);
    this.handleClearFilters(this.facetForm);
    this.handlePagination();
    this.handleSortBy(this.facetForm);
    if (this.collectionDetail) this.handleCollectionDetail();
  }

  handleFacets(form) {
    form.addEventListener(
      "input",
      debounce((event) => {
        const searchParams = this.createSearchParams(
          event.target.closest("form")
        );
        this.fetchPage(searchParams);
        this.updateURLHash(searchParams);
        this.handleApplybutton();
        this.toggleSpinner("show");
        scroll({ top: 0, behavior: "smooth" });
      }, 300).bind(this)
    );
  }

  handleClearFilters(form) {
    const clearFilters = form.querySelectorAll(".js-clear-filter");
    if (!clearFilters) return;

    clearFilters.forEach((filter) => {
      filter.addEventListener("click", (event) => {
        event.preventDefault();
        const searchParams = this.stripUrl(filter.href);
        this.fetchPage(searchParams);
        this.updateURLHash(searchParams);
        this.handleApplybutton();
        this.toggleSpinner("show");
        scroll({ top: 0, behavior: "smooth" });
      });
    });
  }

  handlePagination() {
    new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const paginateNext = this.paginateNext.querySelector(
            ".js-pagination-link"
          );
          if (!paginateNext) return;
          const searchParams = this.stripUrl(paginateNext.href);
          this.fetchPage(searchParams, "append");
          this.toggleSpinner("show", this.paginateNext);
        }
      },
      { rootMargin: "100%" }
    ).observe(this.paginateNext);
  }

  handleSortBy(form) {
    const sortByInput = form.querySelector(".js-sortby-input");
    this.sortByItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        const sortfilter = document.querySelector(".sort-by-field");
        sortfilter.classList.remove("sort-field-show");
        document
          .querySelector(".filter-select")
          .setAttribute("aria-expanded", "false");
        document
          .querySelector(".filter-select")
          .querySelector("span").innerHTML = item.innerHTML;

        sortByInput.value = item.getAttribute("value");
        form.dispatchEvent(new CustomEvent("input", { bubbles: true }));
      });
    });
  }
  handleApplybutton() {
    const elApplyLabel = this.querySelector(".js-filters-apply-label");
    const elApplyLoading = this.querySelector(".js-filters-apply-loading");

    elApplyLabel.classList.toggle("is-hidden");
    elApplyLoading.classList.toggle("is-hidden");
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  stripUrl(url) {
    const searchParams = url.split("?")[1];
    return searchParams === undefined ? "" : searchParams;
  }

  fetchPage(searchParams, mode = "replace") {
    const url = `${window.location.pathname}?section_id=${this.sectionID}&${searchParams}`;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const page = parser.parseFromString(html, "text/html");
        this.updatePage(page, mode);
        this.updateFilters(page);
        this.updateCount(page);
        this.updatePagination(page);
        this.handleClearFilters(this.facetForm);
        this.handleSortBy(this.facetForm);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        this.toggleSpinner();
      });
  }

  updatePage(page, mode) {
    const newPage = page.querySelector(".js-product-grid");
    const productsHTML = newPage.innerHTML;
    if (mode === "append") {
      this.collectionGrid.insertAdjacentHTML("beforeend", productsHTML);
    } else {
      this.collectionGrid.innerHTML = productsHTML;
    }
  }

  updateFilters(page) {
    const updatedFilters = page.querySelector(".js-filters-form").innerHTML;
    this.facetForm.innerHTML = updatedFilters;

    updateApplyButtonCount: {
      const elApplyButton = this.querySelector(".js-filters-apply");
      const elNewApplyButton = page.querySelector(".js-filters-apply");
      if (elNewApplyButton)
        elApplyButton.innerHTML = elNewApplyButton.innerHTML;
    }
  }

  updateCount(page) {
    const newContent = page.querySelector(".js-product-count");
    if (!newContent) return;
    this.productCount.innerHTML = newContent.innerHTML;
  }

  updatePagination(page) {
    const nextPagination = page.querySelector(".js-pagination-next");
    this.paginateNext.innerHTML = nextPagination.innerHTML;
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  toggleSpinner(type, container = this.element) {
    const spinner = container.querySelector(".js-load-more-spinner");
    if (spinner) {
      spinner.style.display = type === "show" ? "block" : "none";
    }
  }

  handleCollectionDetail() {
    var firstParagrap = this.collectionDetail.querySelector("p");
    firstParagrap.classList.add("paragrap-over");

    this.readMore = this.element.querySelector(".js-read-more");
    this.readLess = this.element.querySelector(".js-less");

    this.readMore.addEventListener("click", (e) => {
      firstParagrap.classList.remove("paragrap-over");
    });

    this.readLess.addEventListener("click", (e) => {
      firstParagrap.classList.add("paragrap-over");
    });
  }
}

customElements.define("collection-section", CollectionSection);

class JunoPage extends HTMLElement {
  static handleScroll() {
    const handler = debounce(() => {
      const elLastPage = document.querySelector("juno-page:last-child");
        const url = new URL(window.location.href);
        const pageNumber = elLastPage.dataset.page;
        if (url.searchParams.get("page") !== pageNumber) {
          if (pageNumber == "1") {
            url.searchParams.delete("page");
          } else {
            url.searchParams.set("page", pageNumber);
          }
          history.replaceState(null, "", url);
          document.title = document.title.replace(
            /Page (\d)/,
            `Page ${pageNumber}`
          );
        }
    }, 64);
    window.addEventListener("scroll", handler);
  }

  get page() {
    return +this.getAttribute("data-page");
  }

  get sectionId() {
    return this.getAttribute("data-section");
  }

  get hydrated() {
    return this.hasAttribute("hydrated");
  }

  get reconcile() {
    return this.hasAttribute("reconcile");
  }

  constructor() {
    super();
    if (this.reconcile) {
      this.hydratePage();
    } else if (!this.hydrated) {
      new IntersectionObserver(
        ([entry], observer) => {
          if (entry.isIntersecting) {
            this.hydratePage();
            observer.disconnect();
          }
        },
        { rootMargin: "100%" }
      ).observe(this);
    }
  }

  async hydratePage() {
    this.classList.add("is-loading");

    // Get current url
    const url = new URL(window.location.href);
    // Update page param
    url.searchParams.set("page", this.page);
    url.searchParams.set("section_id", this.sectionId);
    url.searchParams.set("view", "ajax");

    const responseHTML = await fetch(url).then((response) => response.text());
    const elFetchedSection = new DOMParser().parseFromString(
      responseHTML,
      "text/html"
    );

    const elGrid = elFetchedSection.querySelector(
      `.js-product-grid juno-page[data-page="${this.page}"]`
    );

    if (this.reconcile) {
      this.classList.remove("is-loading");
      this.setAttribute("hydrated", "");
      for (
        let c1 = Array.from(this.children),
          c2 = Array.from(elGrid.children),
          i = 0;
        i < this.childElementCount;
        i++
      ) {
        if (c1[i].nodeName === "PRODUCT-CARD-PLACEHOLDER") c1[i].replaceWith(c2[i]);
      }
    } else {
      elGrid.setAttribute("hydrated", "");
      this.replaceWith(elGrid);
    }
  }
}

JunoPage.handleScroll();
customElements.define("juno-page", JunoPage);
